import React from 'react'

const DappconInvader = ({ width = 41, height = 43, fill = '#000', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 41 43"
    {...props}
  >
    <path
      fill={fill}
      fillRule="evenodd"
      d="M7 37h10.52c2.4 0 4.57-.375 6.52-1.13 1.95-.753 3.577-1.807 4.878-3.164 1.304-1.355 2.309-2.985 3.017-4.89.712-1.903 1.065-3.99 1.065-6.263 0-2.274-.368-4.367-1.104-6.286-.738-1.916-1.776-3.558-3.113-4.922-1.336-1.363-2.981-2.43-4.937-3.195C21.887 6.384 19.74 6 17.396 6H7v31zm6.965-6.498V12.52h3.598c1.513 0 2.892.39 4.133 1.17 1.24.781 2.207 1.863 2.903 3.24.697 1.376 1.044 2.92 1.044 4.623 0 .994-.131 1.945-.392 2.855a8.573 8.573 0 0 1-1.139 2.46 8.451 8.451 0 0 1-1.776 1.919c-.688.546-1.48.97-2.378 1.267a9.043 9.043 0 0 1-2.87.448h-3.123z"
    />
  </svg>
)

export default DappconInvader
